<template>
    <div class="store-details-page">
        <!-- 头部组件 -->
        <Header />

        <!-- 容器 -->
        <div class="container">

            <!-- 顶部导航路径 -->
            <div class="breadcrumb">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{
                        name: 'home', params: {
                            activeName: '2',
                        },
                    }">供应大厅</el-breadcrumb-item>
                    <el-breadcrumb-item>商家详情</el-breadcrumb-item>
                </el-breadcrumb>
            </div>

            <!-- 顶部Banner 轮播 -->
            <div class="store-banner" v-if="bannerList.length">
                <el-carousel height="200px"
                    :autoplay="bannerList.length > 1"
                    :loop="bannerList.length > 1"
                    :indicator-position="bannerList.length > 1 ? 'outside' : 'none'">
                    <el-carousel-item v-for="(img, index) in bannerList" :key="index">
                        <img :src="img" alt="商家Banner" class="banner-image">
                    </el-carousel-item>
                </el-carousel>
            </div>

            <!-- 商家信息 -->
            <div class="store-info">
                <div class="container">
                    <div class="store-info-content">
                        <div class="left">
                            <div class="store-logo">
                                <img :src="storeInfo.store_logo" alt="商家Logo" class="logo-image">
                            </div>
                            <div class="store-info-main">
                                <h2 class="store-name">{{ storeInfo.store_name }}</h2>
                                <div class="store-rating">
                                    <div class="merchant-rating">
                                        <el-rate disabled v-model="storeInfo.store_star"
                                            score-template="{value}"></el-rate>
                                        <span class="follower-count">{{ storeInfo.store_collection_num || 0 }}人关注</span>
                                    </div>
                                </div>
                                <div class="store-address">
                                    <span>{{ storeInfo.store_address }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="right">
                            <div class="store-actions">
                                <!-- <el-button class="follow-btn">关注</el-button> -->
                                <el-button class="contact-btn" type="primary" @click="goChat">在线沟通</el-button>
                                <div class="guanzhu" @click="guanzhuFn" v-if="storeInfo.is_attent == 0">
                                    <img src="../../assets/images/31.png" alt="">
                                    <span>关注</span>
                                </div>

                                <div class="guanzhu" @click="cancleGuanzhuFn" v-else>
                                    <img src="../../assets/images/32.png" alt="">
                                    <span>取消关注</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 商品分类导航 -->
            <div class="product-nav">
                <div class="container">
                    <!-- 排序选项 -->
                    <div class="sort-options">
                        <div class="sort-item" @click="sortFn(1)">推荐</div>
                        <div class="sort-item" @click="sortFn(2)">销量
                            <img src="../../assets/images/22.png" :class="{ 'xuanzhuan': xiaoliangStatus == 'desc' }"
                                alt="">
                        </div>
                        <div class="sort-item" @click="sortFn(3)">价格
                            <img src="../../assets/images/22.png" :class="{ 'xuanzhuan': pricaeStatus == 'desc' }"
                                alt="">
                        </div>
                        <!-- <el-dropdown trigger="hover" popper-class="province-dropdown">
                            <div class="sort-item">
                                {{ provinceName || '全国' }}
                                <img src="../../assets/images/23.png" alt="" style="width: 6px;height: 6px;">
                            </div>
                            <el-dropdown-menu slot="dropdown">
                                <div class="province-list">
                                    <div v-for="province in provinces" :key="province.aid" class="province-item"
                                        @click="selectProvince(province)">
                                        {{ province.province_name }}
                                    </div>
                                </div>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <div class="sort-item">附近货源</div> -->
                    </div>
                </div>
            </div>

            <!-- 商品列表 -->
            <div class="product-list">
                <div class="container">
                    <el-empty description="暂无数据" v-if="productList.length == 0"></el-empty>

                    <div class="product-grid" v-else>
                        <div class="product-item" v-for="(product, index) in productList" :key="index"
                            @click="goDetails(product)">
                            <div class="product-image">
                                <img :src="product.image" :alt="product.name" class="product-thumb">
                            </div>
                            <div class="product-info">
                                <div class="product-name">{{ product.storeName }}</div>

                                <div class="product-basic">
                                    <div class="product-price">
                                        <span class="price-sign">¥</span>
                                        <span class="price-value">{{ product.shop_price }}</span>
                                    </div>
                                    <div class="product-sales">销量{{ product.sales_sum }}</div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <!-- 分页控件 -->
                    <div class="pagination-container">
                        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                            :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                            layout="total, sizes, prev, pager, next, jumper" :total="totalOrders">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>



        <!-- 底部组件 -->
        <Footer />
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import { ensureGoEasyConnected } from '@/utils/goeasy'

export default {
    name: 'StoreDetails',
    components: {
        Header,
        Footer
    },
    data() {
        return {
            storeInfo: {},
            sort_field: '1',
            sort_type: 'asc', //desc 倒序

            xiaoliangStatus: 'asc', // 销量排序状态
            pricaeStatus: 'asc', // 价格排序状态

            // 分页数据
            currentPage: 1,
            pageSize: 10,
            totalOrders: 0,
            productList: []
        }

    },
    computed: {
        bannerList() {
            const raw = this.storeInfo && this.storeInfo.store_backdrop
            if (!raw) return []
            if (Array.isArray(raw)) return raw // 后端已返回数组，直接命中
            if (typeof raw === 'string') {
                return raw.split(',').map(s => s.trim()).filter(Boolean)
            }
            return []
        }
    },
    mounted() {
        this.getStoreInfo()
        this.getStoreProductList()
    },
    methods: {
        // 获取商家详情
        getStoreInfo() {
            this.$api.getStoreInfo({
                aid: this.$route.query.id
            }).then(res => {
                this.storeInfo = res
            }).catch(err => {
                this.$message.error(err)
            })
        },

        // 关注/取消关注
        guanzhuFn() {
            this.$dapi.guanzhuShop({
                shop_id: this.storeInfo.store_id,
            }).then(res => {
                this.$message({
                    message: '关注成功',
                    type: 'success'
                })
                this.storeInfo.is_attent = 1
            }).catch(err => {
                this.$message.error(err);
            })
        },
        // 取消关注店铺
        cancleGuanzhuFn() {
            this.$dapi.cancleGuanzhuShop({
                shop_id: this.storeInfo.store_id,
            }).then(res => {
                this.$message({
                    message: '取消关注成功',
                    type: 'success'
                })
                this.storeInfo.is_attent = 0
            }).catch(err => {
                this.$message.error(err);
            })
        },

        // 获取商家店铺商品列表
        getStoreProductList() {
            this.$api.getStoreProductList({
                store_id: this.$route.query.id,
                // keyword: this.keyword,
                type: this.sort_field,
                sort: this.sort_type,
                page: this.currentPage,
                list_rows: this.pageSize,
            }).then(res => {
                this.productList = res.data
                this.totalOrders = res.total;
            }).catch(err => {
                this.$message.error(err)
            })
        },


        // 分页方法
        handleSizeChange(val) {
            this.pageSize = val;
            this.getStoreProductList();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getStoreProductList();
        },


        // 排序方法
        sortFn(type) {
            if (type == 2) {
                // 销量
                this.sort_type = this.sort_type == 'asc' ? 'desc' : 'asc'
                this.xiaoliangStatus = this.sort_type == 'asc' ? 'desc' : 'asc'
            } else if (type == 3) {
                // 价格
                this.sort_type = this.sort_type == 'asc' ? 'desc' : 'asc'
                this.pricaeStatus = this.sort_type == 'asc' ? 'desc' : 'asc'
            }
            this.sort_field = type
            this.getStoreProductList();
        },

        // 跳转详情页
        goDetails(product) {
            this.$router.push({
                path: '/ShopDetails',
                query: {
                    id: product.id
                }
            })
        },

        // 在线沟通：跳转到聊天页与商家新建/打开对话
        goChat() {
            if (!this.$store.getters.isLoggedIn) {
                this.$message.warning('请先登录')
                this.$router.push('/login')
                return
            }
            const toUserId = this.storeInfo.user_id || this.storeInfo.store_id
            if (!toUserId) {
                this.$message.warning('未获取到商家信息')
                return
            }
            const user = this.$store.getters.getUserInfo
            ensureGoEasyConnected(user).then((connected) => {
                if (!connected) {
                    this.$message.error('聊天连接失败，请稍后重试')
                    return
                }
                this.$router.push({
                    name: 'message',
                    query: {
                        toUserId: String(toUserId),
                        toName: this.storeInfo.store_name || '',
                        toAvatar: this.storeInfo.store_logo || ''
                    }
                })
            })
        },

    }
}
</script>

<style scoped>
.store-details-page {
    font-family: Arial, sans-serif;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    background-color: #f8f8f8;
}

/* 面包屑导航 */
.breadcrumb {
    padding: 24px 0 20px 0;
    width: 1200px;
    margin: 0 auto;
}

/* Banner样式 */
.store-banner {
    width: 100%;
    overflow: hidden;
}

.banner-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.container {
    width: 1200px;
    margin: 0 auto;
}

/* 商家信息样式 */
.store-info {
    /* background-color: #f8f8f8; */
    padding: 20px 0;

}

.store-info-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 24px;
    background-color: #fff;
}

.store-info-content .left {
    display: flex;
    align-items: center;
}

.store-logo {
    margin-right: 20px;
}

.logo-image {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    object-fit: cover;
}

.store-info-main {
    flex: 1;
    text-align: left;
}

.merchant-rating {
    display: flex;
    align-items: center;
    gap: 5px;
}

.store-name {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
    color: #333;
}

.store-rating {
    margin-bottom: 10px;
}

.rating-star {
    color: #ffc107;
    margin-right: 5px;
}

.rating-score {
    margin-right: 10px;
    color: #333;
}

.follower-count {
    color: #666;
}

.store-address {
    color: #666;
    font-size: 14px;
}

.store-actions {
    display: flex;
    gap: 10px;
    flex-direction: column;
    font-size: 14px;
    color: #999999;
}

.store-actions img {
    width: 16px;
    height: 16px;
}

.store-actions .guanzhu {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
}

/* 商品导航样式 */
.product-nav {
    background-color: #fff;
    border-bottom: 1px solid #eee;
    padding: 15px 0;
}

.nav-tabs {
    display: flex;
    gap: 30px;
}

.nav-tab {
    cursor: pointer;
    padding: 5px 0;
    color: #666;
    font-size: 16px;
    border-bottom: 2px solid transparent;
    transition: all 0.3s ease;
}

.nav-tab:hover,
.nav-tab.active {
    color: #409eff;
    border-bottom-color: #409eff;
}

/* 商品列表样式 */
.product-list {
    padding: 20px 0;
    background-color: #f8f8f8;
}

.product-grid {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 20px;
}

.product-item {
    background-color: #fff;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease;
}

.product-item:hover {
    transform: translateY(-5px);
}

.product-image {
    height: 150px;
    overflow: hidden;
}

.product-thumb {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.product-info {
    padding: 15px;
    text-align: left;
}

.product-basic {
    display: flex;
    /* align-items: center; */
    justify-content: space-between;
}

.product-price {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
}

.price-sign {
    color: #ff4d4f;
    font-size: 14px;
}

.price-value {
    color: #ff4d4f;
    font-size: 20px;
    font-weight: bold;
}

.price-unit {
    color: #666;
    font-size: 12px;
    margin-left: 2px;
}

.product-name {
    font-size: 14px;
    color: #333;
    margin-bottom: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    line-clamp: 2;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

.product-sales {
    font-size: 12px;
    color: #999;
}

.contact-btn {
    width: 128px;
    height: 40px;
    background: #FFFFFF;
    border-radius: 2px 2px 2px 2px;
    border: 1px solid #2563E5;
    font-size: 16px;
    color: #286CED;
}

/* 排序选项 */
.sort-options {
    display: flex;
    gap: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #e0e0e0;
    margin-bottom: 20px;
}

.sort-item {
    font-size: 14px;
    color: #666666;
    cursor: pointer;
    transition: all 0.3s;
    padding: 6px 12px;
    border-radius: 4px;
}

.sort-item:hover {
    color: #286CED;
    background-color: #f0f4ff;
}

.sort-item.active {
    color: #286CED;
    font-weight: bold;
    background-color: #e8f0fe;
}

.xuanzhuan {
    transform: rotate(180deg);
}

.sort-item img {
    width: 6px;
    height: 9px;
}

/* 分页容器 */
.pagination-container {
    background-color: #ffffff;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
    text-align: right;
    text-align: center;
    width: 1200px;
    margin: 0 auto;
    margin-top: 20px;

}

/* 响应式设计 */
@media (max-width: 1200px) {
    .product-grid {
        grid-template-columns: repeat(4, 1fr);
    }
}

@media (max-width: 992px) {
    .product-grid {
        grid-template-columns: repeat(3, 1fr);
    }
}

@media (max-width: 768px) {
    .store-info-content {
        flex-direction: column;
        align-items: flex-start;
    }

    .store-actions {
        margin-top: 20px;
    }

    .product-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 576px) {
    .product-grid {
        grid-template-columns: 1fr;
    }
}
</style>
